import { ref, computed } from 'vue'
import type { SuperAdmin } from '@/types/auth'
import {
  login as apiLogin,
  logout as apiLogout,
  fetchCurrentSuperAdmin as apiFetchCurrentSuperAdmin,
} from '@/api/auth'

const superAdmin = ref<SuperAdmin | null>(null)
const isLoading = ref(false)

const isAuthenticated = computed(() => superAdmin.value !== null)

async function login(email: string, password: string): Promise<void> {
  const response = await apiLogin({ email, password })
  localStorage.setItem('startline_admin_token', response.token)
  superAdmin.value = response.data
}

async function fetchCurrentSuperAdmin(): Promise<void> {
  isLoading.value = true
  try {
    superAdmin.value = await apiFetchCurrentSuperAdmin()
  } catch {
    superAdmin.value = null
  } finally {
    isLoading.value = false
  }
}

async function logout(): Promise<void> {
  try {
    await apiLogout()
  } finally {
    localStorage.removeItem('startline_admin_token')
    superAdmin.value = null
  }
}

export function useAdminAuth() {
  return {
    superAdmin,
    isAuthenticated,
    isLoading,
    login,
    logout,
    fetchCurrentSuperAdmin,
  }
}
